// extracted by mini-css-extract-plugin
export var header = "_h7-0";